import { OnboardingPoints } from './OnboardingPoints';

export const NextCategory = (point) => {
    const nowPoint = OnboardingPoints.find(i => i.value === point)?.key;
if(nowPoint && nowPoint < 9) {
    return OnboardingPoints.find(i => i.key === nowPoint + 1)?.value;
}
};